export interface IMedLocation {
  location: string;
  name: string;
}
export const MEDLocations: IMedLocation[] = [
  { location: 'MED-002', name: 'VA-Burke' },
  { location: 'MED-003', name: 'MD-Chevy Chase' },
  { location: 'MED-004', name: 'VA-Reston' },
  { location: 'MED-005', name: 'DC-L Street' },
  { location: 'MED-006', name: 'MD-Forestville' },
  { location: 'MED-007', name: 'MD-Fallsgrove' },
  { location: 'MED-008', name: 'VA-Potomac Mills' },
  { location: 'MED-009', name: 'DC-Dupont Circle' },
  { location: 'MED-011', name: 'MD-Olney' },
  { location: 'MED-012', name: 'VA-Clarendon' },
  { location: 'MED-014', name: 'VA-Fairfax' },
  { location: 'MED-015', name: 'MD-Silver Spring' },
  { location: 'MED-016', name: 'VA-Springfield' },
  { location: 'MED-019', name: 'VA-Gainesville' },
  { location: 'MED-020', name: 'VA-Vienna' },
  { location: 'MED-022', name: 'VA-Ballston' },
  { location: 'MED-023', name: 'MD-Oxon Hill' },
  { location: 'MED-024', name: 'MD-Rockville Pike' },
  { location: 'MED-025', name: 'VA-Stafford' },
  { location: 'MED-026', name: 'VA-Lorton' },
  { location: 'MED-027', name: 'VA-Leesburg' },
  { location: 'MED-028', name: 'VA-Alexandria-Duke St.' },
  { location: 'MED-029', name: 'VA-Sterling' },
  { location: 'MED-030', name: 'MD-Aspen Hill' },
  { location: 'MED-031', name: 'MD-Bethesda' },
  { location: 'MED-032', name: 'MD-Greenbelt Rd.' },
  { location: 'MED-034', name: 'VA-Centreville' },
  { location: 'MED-035', name: 'MD-Germantown' },
  { location: 'MED-038', name: 'DC-Eye Street' },
  { location: 'MED-039', name: 'MD-Cabin John' },
  { location: 'MED-040', name: 'VA-Bristow' },
  { location: 'MED-041', name: 'MD-Kentlands' },
  { location: 'MED-042', name: 'MD-Annapolis' },
  { location: 'MED-043', name: 'DC-Pennsylvania Ave' },
  { location: 'MED-044', name: 'VA-Liberia' },
  { location: 'MED-046', name: 'MD-Frederick' },
  { location: 'MED-047', name: 'MD-Columbia' },
  { location: 'MED-048', name: 'VA-Falls Church' },
  { location: 'MED-049', name: 'MD-Hyattsville' },
  { location: 'MED-050', name: 'MD-Bowie' },
  { location: 'MED-051', name: 'VA-Merrifield' },
  { location: 'MED-052', name: 'VA-Alexandria-Rt.1' },
  { location: 'MED-053', name: 'MD-Eldersburg' },
  { location: 'MED-054', name: 'MD-Pikesville' },
  { location: 'MED-055', name: 'VA-Pentagon City' },
  { location: 'MED-056', name: 'VA-McLean' },
  { location: 'MED-057', name: 'VA-Winchester' },
  { location: 'MED-058', name: 'MD-Dunkirk' },
  { location: 'MED-059', name: 'VA-Front Royal' },
  { location: 'MED-060', name: 'MD-Prince Frederick' },
  { location: 'MED-061', name: 'MD-Canton Crossing' },
  { location: 'MED-063', name: 'MD-Charlotte Hall' },
  { location: 'MED-064', name: 'MD-Towson' },
  { location: 'MED-065', name: 'MD-Waldorf' },
  { location: 'MED-066', name: 'VA-One Loudoun' },
  { location: 'MED-067', name: 'DC-Gallery Place' },
  { location: 'MED-068', name: 'MD-Hunt Valley' },
  { location: 'MED-069', name: 'MD-Laurel' },
  { location: 'MED-070', name: 'VA-Westfield Road' },
  { location: 'MED-071', name: 'MD-Ellicott City' },
  { location: 'MED-072', name: 'NC-Laurinburg' },
  { location: 'MED-073', name: 'SC-Greer' },
  { location: 'MED-074', name: 'NC-Crabtree Valley Mall' },
  { location: 'MED-076', name: 'GA-Thomasville' },
  { location: 'MED-077', name: 'FL-Crawfordville' },
  { location: 'MED-078', name: 'FL-Timberlane Road' },
  { location: 'MED-079', name: 'FL-Parkway' },
  { location: 'MED-080', name: 'GA-Albany' },
  { location: 'MED-082', name: 'FL-Perry' },
  { location: 'MED-083', name: 'NC-Greensboro-ElmStreet' },
  { location: 'MED-084', name: 'VA-South Riding' },
  { location: 'MED-085', name: 'GA-Waycross Mall' },
  { location: 'MED-086', name: 'MD-Havre De Grace' },
  { location: 'MED-089', name: 'MD-Elkton' },
  { location: 'MED-090', name: 'MD-Aberdeen' },
  { location: 'MED-091', name: 'MD-Forest Hill' },
  { location: 'MED-092', name: 'VA-Harrisonburg-Parkview' },
  { location: 'MED-094', name: 'NC-Huntersville' },
  { location: 'MED-095', name: 'GA-Woodstock Mall' },
  { location: 'MED-096', name: 'SC-Greenville-Wade Hampton' },
  { location: 'MED-097', name: 'VA-Fredericksburg- South Point' },
  { location: 'MED-098', name: 'VA-Tysons Corner' },
  { location: 'MED-099', name: 'MD-California- Eye Care Plaza' },
  { location: 'MED-100', name: 'MD-Bowie- Gateway Center' },
  { location: 'MED-103', name: 'MD-Waldorf- Crain Highway' },
  { location: 'MED-104', name: 'MD-Germantown- Town Square' },
  { location: 'MED-107', name: 'VA-Harrisonburg-Reservoir Street' },
  { location: 'MED-108', name: 'VA-Warrenton' },
  { location: 'MED-109', name: 'VA-Staunton' },
  { location: 'MED-111', name: 'FL-St. Johns' },
  { location: 'MED-112', name: 'FL-Jacksonville - Normandy' },
  { location: 'MED-113', name: 'FL-St. Augustine' },
  { location: 'MED-114', name: 'MD-Harford Mall' },
  { location: 'MED-115', name: 'VA-Baileys Crossroads' },
  { location: 'MED-116', name: 'DE-Dover' },
  { location: 'MED-117', name: 'DE-West Dover' },
  { location: 'MED-118', name: 'DE-Milford' },
  { location: 'MED-119', name: 'DE-Smyrna' },
  { location: 'MED-120', name: 'DE-Seaford' },
  { location: 'MED-121', name: 'DE-Georgetown' },
  { location: 'MED-122', name: 'DE-Middletown' },
  { location: 'MED-123', name: 'DE-Millville' },
  { location: 'MED-124', name: 'DE-Bear' },
  { location: 'MED-125', name: 'DE-Wilmington-Kirkwood Hwy' },
  { location: 'MED-126', name: 'FL-Kissimmee' },
  { location: 'MED-127', name: 'FL-Plant City' },
  { location: 'MED-128', name: 'FL-Poinciana' },
  { location: 'MED-129', name: 'FL-Haines City' },
  { location: 'MED-131', name: 'FL-Bartow' },
  { location: 'MED-132', name: 'FL-Sebring' },
  { location: 'MED-133', name: 'FL-Clermont' },
  { location: 'MED-134', name: 'FL-Winter Haven' },
  { location: 'MED-135', name: 'FL-South Lakeland' },
  { location: 'MED-136', name: 'FL-Central Lakeland' },
  { location: 'MED-137', name: 'FL-North Lakeland' },
  { location: 'MED-138', name: 'GA-Alpharetta' },
  { location: 'MED-139', name: 'GA-Cartersville' },
  { location: 'MED-140', name: 'GA-Canton' },
  { location: 'MED-141', name: 'GA-Woodstock' },
  { location: 'MED-142', name: 'GA-Brookhaven' },
  { location: 'MED-144', name: 'GA-Cumberland Pointe' },
  { location: 'MED-145', name: 'GA-Lawrenceville' },
  { location: 'MED-146', name: 'GA-Suwanee' },
  { location: 'MED-147', name: 'GA-Sandy Springs' },
  { location: 'MED-148', name: 'GA-Lindbergh Plaza' },
  { location: 'MED-149', name: 'MD-Thurmont' },
  { location: 'MED-150', name: 'CT-Ansonia' },
  { location: 'MED-151', name: 'CT-Cheshire' },
  { location: 'MED-152', name: 'CT-Danbury' },
  { location: 'MED-153', name: 'CT-Fairfield' },
  { location: 'MED-154', name: 'CT-Hamden' },
  { location: 'MED-155', name: 'CT-Madison' },
  { location: 'MED-156', name: 'CT-Naugatuck' },
  { location: 'MED-157', name: 'CT-New Haven' },
  { location: 'MED-158', name: 'CT-New Milford' },
  { location: 'MED-159', name: 'CT-Norwalk' },
  { location: 'MED-160', name: 'CT-Ridgefield' },
  { location: 'MED-161', name: 'CT-Southbury' },
  { location: 'MED-162', name: 'CT-Torrington' },
  { location: 'MED-163', name: 'CT-Trumbull' },
  { location: 'MED-164', name: 'CT-Waterbury-Grandview' },
  { location: 'MED-165', name: 'CT-Waterbury-Lakewood' },
  { location: 'MED-166', name: 'CT-Watertown' },
  { location: 'MED-167', name: 'CT-Westport' },
  { location: 'MED-168', name: 'GA-Briarcliff Village' },
  { location: 'MED-169', name: 'FL-Oakleaf Town Center' },
  { location: 'MED-170', name: 'VA-Charlottesville-Sachem' },
  { location: 'MED-171', name: 'VA-Charlottesville-Pantops' },
  { location: 'MED-172', name: 'IL-Andersonville' },
  { location: 'MED-173', name: 'IL-Evanston Central St.' },
  { location: 'MED-174', name: 'IL-Chicago Avenue' },
  { location: 'MED-175', name: 'IL-Evanston Dempster St.' },
  { location: 'MED-176', name: 'IL-East Madison' },
  { location: 'MED-177', name: 'IL-Elmhurst' },
  { location: 'MED-179', name: 'IL-Grayslake' },
  { location: 'MED-180', name: 'IL-Clybourn Commons' },
  { location: 'MED-182', name: 'IL-Highland Park' },
  { location: 'MED-184', name: 'IL-Hinsdale' },
  { location: 'MED-186', name: 'IL-Lakeview' },
  { location: 'MED-188', name: 'IL-Vernon Hills' },
  { location: 'MED-189', name: 'IL-Lincoln Square' },
  { location: 'MED-190', name: 'IL-Naperville' },
  { location: 'MED-191', name: 'IL-Oak Park' },
  { location: 'MED-192', name: 'IL-Old Town' },
  { location: 'MED-193', name: 'IL-North Center' },
  { location: 'MED-194', name: 'IL-West Loop' },
  { location: 'MED-195', name: 'IL-Wicker Park' },
  { location: 'MED-197', name: 'MD-La Plata' },
  { location: 'MED-198', name: 'NC-Clayton' },
  { location: 'MED-201', name: 'FL-Gainesville' },
  { location: 'MED-202', name: 'FL-Ocala' },
  { location: 'MED-203', name: 'FL-Triple Crown' },
  { location: 'MED-204', name: 'MD-Parkville' },
  { location: 'MED-205', name: 'MD-Annapolis-Riva Road' },
  { location: 'MED-206', name: 'MD-Arundel Mills' },
  { location: 'MED-207', name: 'MD-Bel Air-Festival' },
  { location: 'MED-211', name: 'MD-Salisbury' },
  { location: 'MED-214', name: 'MD-Westminster' },
  { location: 'MED-216', name: 'FL-Riverside' },
  { location: 'MED-217', name: 'SC-Manning' },
  { location: 'MED-218', name: 'SC-Long Point' },
  { location: 'MED-219', name: 'FL-Miccosukee Road' },
  { location: 'MED-220', name: 'CT-New Milford Shopping Plaza' },
  { location: 'MED-221', name: 'FL-Middleburg' },
  { location: 'MED-222', name: 'GA-Columbus' },
  { location: 'MED-223', name: 'CT-Winsted' },
  { location: 'MED-224', name: 'VA-Beach-Mall Drive' },
  { location: 'MED-225', name: 'DC-Cathedral Commons' },
  { location: 'MED-226', name: 'VA-Birchwood Shopping Center' },
  { location: 'MED-227', name: 'VA-Kemps River Shopping Center' },
  { location: 'MED-229', name: 'VA- Hampton' },
  { location: 'MED-230', name: 'VA-Greenbrier Mall' },
  { location: 'MED-231', name: 'VA- Portsmouth Blvd' },
  { location: 'MED-232', name: 'VA-Monticello Marketplace Shoppes' },
  { location: 'MED-233', name: 'VA-Patrick Henry Mall' },
  { location: 'MED-234', name: 'MD-La Vale' },
  { location: 'MED-235', name: 'MD-Hagerstown - Valley Mall' },
  { location: 'MED-236', name: 'MD-Hagerstown - The Lyles Center' },
  { location: 'MED-237', name: 'MD-Hagerstown - Dual Highway' },
  { location: 'MED-238', name: 'MD-Francis Scott Key Mall' },
  { location: 'MED-240', name: 'PA-Greencastle' },
  { location: 'MED-241', name: 'PA-Chambersburg - Wayne Ave.' },
  { location: 'MED-243', name: 'PA-Carlisle Commons' },
  { location: 'MED-244', name: 'PA-Carlisle - York Road' },
  { location: 'MED-245', name: 'PA-Shippensburg' },
  { location: 'MED-246', name: 'PA-Waynesboro' },
  { location: 'MED-247', name: 'VA-Leesburg - Battlefield Shopping Center' },
  { location: 'MED-248', name: 'VA-Winchester - Pleasant Valley Rd' },
  { location: 'MED-249', name: 'WV-Martinsburg - Foxcroft Ave' },
  { location: 'MED-250', name: 'WV-Martinsburg - Williamsport Pike' },
  { location: 'MED-251', name: 'WV-Charles Town' },
  { location: 'MED-252', name: 'MD-Nottingham Commons' },
  { location: 'MED-253', name: 'MD-Easton' },
  { location: 'MED-254', name: 'FL-Orange Park Place Plaza' },
  { location: 'MED-255', name: 'IL-Joliet' },
  { location: 'MED-256', name: 'VA-Culpeper' },
  { location: 'MED-257', name: 'IL-Oak Lawn' },
  { location: 'MED-258', name: 'PA-Chambersburg-Gateway Center' },
  { location: 'MED-259', name: 'IL-Calumet' },
  { location: 'MED-260', name: 'PA-East York' },
  { location: 'MED-261', name: 'PA-Manchester Town Center' },
  { location: 'MED-262', name: 'PA-Shrewsbury' },
  { location: 'MED-263', name: 'FL-Jacksonville-Atlantic Blvd' },
  { location: 'MED-264', name: 'IL-Naperville- East Ogden Ave' },
  { location: 'MED-265', name: 'IL-Gurnee' },
  { location: 'MED-266', name: 'NC-Cornelius' },
  { location: 'MED-267', name: 'FL-Lake Wales' },
  { location: 'MED-268', name: 'SC-North Charleston' },
  { location: 'MED-272', name: 'VA-Herndon' },
  { location: 'MED-273', name: 'IL-Lansing' },
  { location: 'MED-274', name: 'FL-Palm Harbor' },
  { location: 'MED-275', name: 'FL-St. Petersburg-Tyrone' },
  { location: 'MED-276', name: 'FL-Tampa-West Bearss' },
  { location: 'MED-277', name: 'FL-St. Petersburg-4th Street' },
  { location: 'MED-278', name: 'FL-Clearwater Mall' },
  { location: 'MED-279', name: 'FL-Seminole' },
  { location: 'MED-280', name: 'VA-Chantilly' },
  { location: 'MED-281', name: 'SC-Fort Mill' },
  { location: 'MED-282', name: 'GA-Chatsworth' },
  { location: 'MED-284', name: 'NC-Ballantyne East' },
  { location: 'MED-285', name: 'GA-Macon' },
  { location: 'MED-287', name: 'VT-Stowe' },
  { location: 'MED-288', name: 'IL-Minooka' },
  { location: 'MED-289', name: 'LA-Uptown' },
  { location: 'MED-290', name: 'LA-Elmwood' },
  { location: 'MED-291', name: 'LA-Manderville' },
  { location: 'MED-292', name: 'LA-Metairie' },
  { location: 'MED-293', name: 'LA-Chateau Commons' },
  { location: 'MED-294', name: 'LA-Boutte' },
  { location: 'MED-295', name: 'PA-Fairless Hills' },
  { location: 'MED-296', name: 'PA-Southhampton' },
  { location: 'MED-297', name: 'PA-Newtown' },
  { location: 'MED-298', name: 'IL-Machesney' },
  { location: 'MED-299', name: 'AL-Hoover' },
  { location: 'MED-300', name: 'AL-Colonnade' },
  { location: 'MED-301', name: 'AL-Inverness' },
  { location: 'MED-303', name: 'AL-Southside' },
  { location: 'MED-304', name: 'AL-Mountain Brook' },
  { location: 'MED-307', name: 'AL-AL-Five Points' },
  { location: 'MED-308', name: 'AL-Trussville' },
  { location: 'MED-310', name: 'AL-Parkway East' },
  { location: 'MED-311', name: 'AL-Providence' },
  { location: 'MED-312', name: 'AL-Madison' },
  { location: 'MED-313', name: 'AL-Whitesburg Dr.' },
  { location: 'MED-315', name: 'AL-Montgomery' },
  { location: 'MED-317', name: 'FL-Boynton Beach' },
  { location: 'MED-318', name: 'VT-Williston' },
  { location: 'MED-319', name: 'FL-Boca Raton' },
  { location: 'MED-320', name: 'FL-Palm Beach Gardens' },
  { location: 'MED-321', name: 'TN-Chattanooga-Market Street' },
  { location: 'MED-322', name: 'MA-Amherst' },
  { location: 'MED-323', name: 'MA-Greenfield' },
  { location: 'MED-331', name: 'FL-Mission Bay' },
  { location: 'MED-333', name: 'IL-Batavia' },
  { location: 'MED-334', name: 'IL-Bolingbrook' },
  { location: 'MED-335', name: 'CT-Newington' },
  { location: 'MED-336', name: 'CT-Rocky Hill' },
  { location: 'MED-337', name: 'CT-Vernon' },
  { location: 'MED-339', name: 'NC-Greenville Blvd-Kirkland Drive' },
  { location: 'MED-340', name: 'NC-Club Pines' },
  { location: 'MED-341', name: 'NC-Greenville-Stantonsburg Rd' },
  { location: 'MED-342', name: 'NC-Morehead City' },
  { location: 'MED-345', name: 'NC-Williamston' },
  { location: 'MED-347', name: 'SC-Pickens' },
  { location: 'MED-348', name: 'GA-McDonough' },
  { location: 'MED-349', name: 'CT-Avon' },
  { location: 'MED-350', name: 'CT-Nutmeg Square' },
  { location: 'MED-351', name: 'CT-Newtown' },
  { location: 'MED-352', name: 'LA-Uptown-Magazine St' },
  { location: 'MED-353', name: 'PA-Hanover' },
  { location: 'MED-354', name: 'PA-Lancaster' },
  { location: 'MED-355', name: 'PA-Newtown-Pheasant Run' },
  { location: 'MED-356', name: 'IN-Anderson' },
  { location: 'MED-357', name: 'IN-Avon' },
  { location: 'MED-359', name: 'IN-South Bloomington' },
  { location: 'MED-360', name: 'IN-Broad Ripple' },
  { location: 'MED-362', name: 'IN-Carmel' },
  { location: 'MED-365', name: 'IN-Downtown' },
  { location: 'MED-366', name: 'IN-Eagle Creek' },
  { location: 'MED-367', name: 'IN-Elkhart' },
  { location: 'MED-368', name: 'IN-Fishers' },
  { location: 'MED-369', name: 'IN-Fort Wayne' },
  { location: 'MED-370', name: 'IN-Greenwood' },
  { location: 'MED-371', name: 'IN-Irvington' },
  { location: 'MED-373', name: 'IN-Lafayette' },
  { location: 'MED-374', name: 'IN-Lebanon' },
  { location: 'MED-375', name: 'IN-Merrillville' },
  { location: 'MED-376', name: 'IN-Michigan City' },
  { location: 'MED-377', name: 'IN-Mishawaka' },
  { location: 'MED-378', name: 'IN-Noblesville' },
  { location: 'MED-380', name: 'IN-Noblesville West' },
  { location: 'MED-381', name: 'IN-Olio' },
  { location: 'MED-382', name: 'IN-Plainfield' },
  { location: 'MED-383', name: 'IN-Shadeland' },
  { location: 'MED-384', name: 'IN-South Bend' },
  { location: 'MED-385', name: 'IN-Southport' },
  { location: 'MED-386', name: 'IN-Spencer' },
  { location: 'MED-387', name: 'IN-Terre Haute' },
  { location: 'MED-388', name: 'IN-Valparaiso' },
  { location: 'MED-389', name: 'IN-Westfield' },
  { location: 'MED-390', name: 'IN-Willow Lake' },
  { location: 'MED-391', name: 'IN-Zionsville' },
  { location: 'MED-392', name: 'AL-Pelham Parkway' },
  { location: 'MED-393', name: 'AL-Calera' },
  { location: 'MED-394', name: 'AL-Clanton' },
  { location: 'MED-395', name: 'TN-Memphis-Moriah Road' },
  { location: 'MED-396', name: 'TN-Memphis Downtown' },
  { location: 'MED-397', name: 'GA-Kennesaw' },
  { location: 'MED-398', name: 'PA-Trappe' },
  { location: 'MED-399', name: 'FL-Wilton Manors' },
  { location: 'MED-400', name: 'VA-Lynchburg' },
  { location: 'MED-401', name: 'NC-Arrowood' },
  { location: 'MED-402', name: 'NC-CIC - Wells Fargo' },
  { location: 'MED-403', name: 'NC-Uptown' },
  { location: 'MED-404', name: 'NC-Randolph' },
  { location: 'MED-405', name: 'NC-Independence Blvd' },
  { location: 'MED-406', name: 'NC-Concord' },
  { location: 'MED-407', name: 'NC-Kannapolis' },
  { location: 'MED-408', name: 'NC-Mint Hill' },
  { location: 'MED-409', name: 'NC-University' },
  { location: 'MED-410', name: 'NC-Statesville' },
  { location: 'MED-411', name: 'NC-South Blvd' },
  { location: 'MED-412', name: 'NC-Henderson' },
  { location: 'MED-413', name: 'NC-Garner-Vandora Springs' },
  { location: 'MED-414', name: 'NC-Swansboro' },
  { location: 'MED-415', name: 'NC-Ballantyne' },
  { location: 'MED-417', name: 'NC-Olde Raleigh' },
  { location: 'MED-419', name: 'NC-Morrisville' },
  { location: 'MED-420', name: 'NC-Apex' },
  { location: 'MED-421', name: 'SC-Rock Hill' },
  { location: 'MED-422', name: 'NC-Roxboro' },
  { location: 'MED-423', name: 'NC-Creedmoor Rd' },
  { location: 'MED-425', name: 'NC-Gastonia-Court Drive' },
  { location: 'MED-426', name: 'NC-High Point' },
  { location: 'MED-427', name: 'NC-Kernersville' },
  { location: 'MED-428', name: 'NC-Fayetteville' },
  { location: 'MED-429', name: 'SC-Mills Ave.' },
  { location: 'MED-430', name: 'NC-Thomasville' },
  { location: 'MED-431', name: 'IL-Elk Grove Village' },
  { location: 'MED-432', name: 'IL-Lake Zurich' },
  { location: 'MED-433', name: 'IL-Park Ridge' },
  { location: 'MED-434', name: 'IL-West Dundee' },
  { location: 'MED-436', name: 'VA-Alexandria Old Town' },
  { location: 'MED-437', name: 'NC-Kinston' },
  { location: 'MED-438', name: 'PA-Doylestown' },
  { location: 'MED-439', name: 'NC-Winston-Salem' },
  { location: 'MED-440', name: 'WI-Kenosha' },
  { location: 'MED-441', name: 'IL-Lincoln Park-North Sheridan' },
  { location: 'MED-442', name: 'AL-Decatur' },
  { location: 'MED-444', name: 'FL-Jacksonville Beach' },
  { location: 'MED-445', name: 'GA-Savannah-Hodgson Memorial Dr.' },
  { location: 'MED-446', name: 'TN-Humboldt' },
  { location: 'MED-447', name: 'TN-Dyersburg' },
  { location: 'MED-448', name: 'TN-Jackson' },
  { location: 'MED-449', name: 'TN-Ripley' },
  { location: 'MED-450', name: 'WV-Parkersburg' },
  { location: 'MED-451', name: 'WV-Spencer' },
  { location: 'MED-452', name: 'PA-New Kensington' },
  { location: 'MED-454', name: 'PA-Pittsburgh-North Hills' },
  { location: 'MED-455', name: 'PA-Pittsburgh-Oakland' },
  { location: 'MED-456', name: 'PA-Beaver Falls' },
  { location: 'MED-457', name: 'PA-Vanport' },
  { location: 'MED-458', name: 'PA-Chippewa' },
  { location: 'MED-459', name: 'PA-Moon Township' },
  { location: 'MED-461', name: 'MD-Silver Spring-Four Corners' },
  { location: 'MED-462', name: 'PA-Oak Park Mall' },
  { location: 'MED-463', name: 'PA-Havertown' },
  { location: 'MED-464', name: 'GA-Columbus-17th Avenue' },
  { location: 'MED-465', name: 'TX-Houston-Willowbrook' },
  { location: 'MED-466', name: 'VA-Lynchburg-Timberlake' },
  { location: 'MED-467', name: 'VA-Lynchburg-Langhorne' },
  { location: 'MED-468', name: 'VA-Appomattox' },
  { location: 'MED-469', name: 'IN-Bloomington-Jackson Creek Shopping Pl' },
  { location: 'MED-470', name: 'IN-Ellettsville' },
  { location: 'MED-471', name: 'VA-Charlottesville-5th St Station' },
  { location: 'MED-472', name: 'VA-Charlottesville- Barracks Rd' },
  { location: 'MED-473', name: 'VA-Charlottesville- Hollymead Town Ctr' },
  { location: 'MED-474', name: 'MA-East Long Meadow-Main St' },
  { location: 'MED-475', name: 'MA-Northampton-Hamp Plaza' },
  { location: 'MED-476', name: 'MA-Springfield-Hamburg St' },
  { location: 'MED-477', name: 'MA-Westfield' },
  { location: 'MED-478', name: 'IN-Chesterton' },
  { location: 'MED-479', name: 'IN-Crown Point' },
  { location: 'MED-480', name: 'IN-La Porte' },
  { location: 'MED-481', name: 'IN-Portage' },
  { location: 'MED-483', name: 'IN-Valparaiso-N. Calumet' },
  { location: 'MED-484', name: 'AR-Arkadelphia' },
  { location: 'MED-486', name: 'AR-Hope' },
  { location: 'MED-487', name: 'AR-Magnolia' },
  { location: 'MED-488', name: 'AR-Mena' },
  { location: 'MED-489', name: 'AR-Nashville' },
  { location: 'MED-490', name: 'OK-Broken Bow' },
  { location: 'MED-491', name: 'OK-Idabel' },
  { location: 'MED-492', name: 'TX-Mt. Pleasant' },
  { location: 'MED-493', name: 'TX-Texarkana-Richmond Road' },
  { location: 'MED-494', name: 'AR-Texarkana-49th Street' },
  { location: 'MED-495', name: 'OH-Dayton-N Main Street' },
  { location: 'MED-496', name: 'MA-Belmont' },
  { location: 'MED-497', name: 'MA-Arlington' },
  { location: 'MED-498', name: 'AL-Trussville-N. Chalkville Rd' },
  { location: 'MED-499', name: 'WI-New Berlin' },
  { location: 'MED-501', name: 'NC-Greenville Blvd' },
  { location: 'MED-502', name: 'NC-Raleigh-New Bern Ave' },
  { location: 'MED-503', name: 'VA-South Hill' },
  { location: 'MED-504', name: 'NC-Wilmington- Hanover' },
  { location: 'MED-505', name: 'NC-Rocky Mount' },
  { location: 'MED-506', name: 'NC-New Bern' },
  { location: 'MED-507', name: 'NC-Washington' },
  { location: 'MED-508', name: 'NC-Madison' },
  { location: 'MED-509', name: 'NC-Wallace' },
  { location: 'MED-510', name: 'NC-Leland' },
  { location: 'MED-512', name: 'NC-Reidsville- PD' },
  { location: 'MED-513', name: 'NC-Wilmington- Racine' },
  { location: 'MED-514', name: 'NC-Eden' },
  { location: 'MED-515', name: 'NC-Wake Forest' },
  { location: 'MED-516', name: 'NC-Adams Farm' },
  { location: 'MED-521', name: 'NC-Cary-Crescent Commons' },
  { location: 'MED-522', name: 'NC-Cary- Cornerstone' },
  { location: 'MED-523', name: 'NC-Zebulon- East Wake' },
  { location: 'MED-524', name: 'NC-Louisburg' },
  { location: 'MED-525', name: 'NC-North Raleigh' },
  { location: 'MED-526', name: 'NC-Townridge' },
  { location: 'MED-527', name: 'NC-Wakefield Commons' },
  { location: 'MED-528', name: 'NC-Cary-Centrum' },
  { location: 'MED-529', name: 'NC-Brier Creek Commons' },
  { location: 'MED-530', name: 'NC-Cameron Village' },
  { location: 'MED-531', name: 'NC-Knightdale' },
  { location: 'MED-532', name: 'NC-Cary- Arboretum' },
  { location: 'MED-533', name: 'NC-Wilmington-Mayfaire' },
  { location: 'MED-534', name: 'NC-Aberdeen' },
  { location: 'MED-535', name: 'NC-Durham- Roxboro Rd.' },
  { location: 'MED-536', name: 'NC-Chapel Hill' },
  { location: 'MED-537', name: 'NC-Raleigh- Leesville' },
  { location: 'MED-538', name: 'NC-Burlington' },
  { location: 'MED-539', name: 'NC-Wilmington- Monkey Junction' },
  { location: 'MED-540', name: 'NC-Garner- White Oak Crossings' },
  { location: 'MED-541', name: 'NC-Durham- Duke Optical' },
  { location: 'MED-542', name: 'NC-Durham- South Square' },
  { location: 'MED-543', name: 'NC-Durham- SouthPoint' },
  { location: 'MED-544', name: 'NC-Wake Forest- Capcom' },
  { location: 'MED-545', name: 'NC-Holly Springs' },
  { location: 'MED-547', name: 'NC-Greensboro- Friendly Center' },
  { location: 'MED-548', name: 'TN-Bartlett' },
  { location: 'MED-549', name: 'TN-Memphis-Regalia' },
  { location: 'MED-550', name: 'TN-Memphis-Cordova' },
  { location: 'MED-551', name: 'TN-Memphis-University' },
  { location: 'MED-552', name: 'TN-Memphis-Winchester' },
  { location: 'MED-553', name: 'PA-Exton Fairfield Center' },
  { location: 'MED-554', name: 'PA-Parkway Shopping Center' },
  { location: 'MED-555', name: 'PA-West Goshen Shopping Center' },
  { location: 'MED-556', name: 'PA-The Shoppes at Longwood Village' },
  { location: 'MED-557', name: 'PA-Caln Village Shopping Center' },
  { location: 'MED-558', name: 'PA-Bethlehem' },
  { location: 'MED-559', name: 'IL-N. Michigan Ave' },
  { location: 'MED-560', name: 'FL-Old St. Augustine Rd' },
  { location: 'MED-561', name: 'AR-EL Dorado' },
  { location: 'MED-562', name: 'IN-Carmel-E. 146th' },
  { location: 'MED-563', name: 'OH-Toledo' },
  { location: 'MED-564', name: 'NC-Hendersonville' },
  { location: 'MED-565', name: 'WI-Fox Point' },
  { location: 'MED-566', name: 'WI-Mequon' },
  { location: 'MED-567', name: 'WI-Fredonia' },
  { location: 'MED-568', name: 'GA-Midtown Atlanta' },
  { location: 'MED-569', name: 'OH-Marion' },
  { location: 'MED-570', name: 'WV-Keyser' },
  { location: 'MED-571', name: 'CT-Orange' },
  { location: 'MED-572', name: 'TX-Watauga' },
  { location: 'MED-573', name: 'IN-Geist' },
  { location: 'MED-574', name: 'MI-Shelby Township' },
  { location: 'MED-575', name: 'OH-Oakwood' },
  { location: 'MED-576', name: 'MI-Cascades' },
  { location: 'MED-577', name: 'SC-Shell Point' },
  { location: 'MED-578', name: 'AL-Cullman' },
  { location: 'MED-579', name: 'WV-Bridgeport' },
  { location: 'MED-580', name: 'WV-Buckhannon' },
  { location: 'MED-581', name: 'PA-Dallastown' },
  { location: 'MED-582', name: 'PA-East York-Eastern Blvd' },
  { location: 'MED-583', name: 'PA-Carlisle-White Street' },
  { location: 'MED-584', name: 'PA-Lititz' },
  { location: 'MED-585', name: 'TX-Missouri City' },
  { location: 'MED-586', name: 'WI-West Side' },
  { location: 'MED-587', name: 'WV-Fairmont' },
  { location: 'MED-588', name: 'NC-Midtown East' },
  { location: 'MED-590', name: 'WI-S. Monroe Ave' },
  { location: 'MED-591', name: 'PA-Rodi' },
  { location: 'MED-592', name: 'PA-Holiday Park' },
  { location: 'MED-593', name: 'MA-State Street' },
  { location: 'MED-594', name: 'MA-Wellesley' },
  { location: 'MED-596', name: 'PA-Indian Springs' },
  { location: 'MED-597', name: 'FL-Mandarin' },
  { location: 'MED-598', name: 'VA-Denbigh' },
  { location: 'MED-599', name: 'VA-Grafton' },
  { location: 'MED-601', name: 'GA-Statesboro' },
  { location: 'MED-603', name: 'GA-Rincon' },
  { location: 'MED-604', name: 'GA-Brunswick' },
  { location: 'MED-605', name: 'GA-Kingsland' },
  { location: 'MED-606', name: 'GA-Dublin' },
  { location: 'MED-607', name: 'GA-Augusta' },
  { location: 'MED-608', name: 'GA-Martinez' },
  { location: 'MED-610', name: 'GA-Warner Robins' },
  { location: 'MED-611', name: 'GA-Milledgeville' },
  { location: 'MED-612', name: 'GA-Pooler' },
  { location: 'MED-613', name: 'GA-Perry' },
  { location: 'MED-614', name: 'KY-Cold Spring' },
  { location: 'MED-615', name: 'KY-Crescent Springs' },
  { location: 'MED-616', name: 'KY-Florence' },
  { location: 'MED-617', name: 'KY-Newport' },
  { location: 'MED-618', name: 'OH-Beechmont' },
  { location: 'MED-619', name: 'OH-Colerain' },
  { location: 'MED-621', name: 'OH-Fairfield' },
  { location: 'MED-622', name: 'OH-Glenway' },
  { location: 'MED-623', name: 'OH-Hamilton' },
  { location: 'MED-624', name: 'OH-Hyde Park' },
  { location: 'MED-625', name: 'OH-Kenwood' },
  { location: 'MED-626', name: 'OH-Liberty' },
  { location: 'MED-627', name: 'OH-Miamisburg' },
  { location: 'MED-628', name: 'OH-Middletown' },
  { location: 'MED-629', name: 'OH-Milford' },
  { location: 'MED-631', name: 'OH-Symmes Township' },
  { location: 'MED-632', name: 'OH-Tri-County' },
  { location: 'MED-634', name: 'OH-Xenia' },
  { location: 'MED-635', name: 'CO-Aurora' },
  { location: 'MED-636', name: 'CO-Downtown Denver' },
  { location: 'MED-637', name: 'CO-Highlands Ranch' },
  { location: 'MED-638', name: 'CO-Lakewood' },
  { location: 'MED-639', name: 'CO-Parker' },
  { location: 'MED-640', name: 'CO-University Hills' },
  { location: 'MED-641', name: 'TX-Longview' },
  { location: 'MED-642', name: 'CO-Boulder' },
  { location: 'MED-643', name: 'OH-Beachwood' },
  { location: 'MED-644', name: 'OH-Hudson' },
  { location: 'MED-645', name: 'CT-Suffield' },
  { location: 'MED-646', name: 'FL-East Broward' },
  { location: 'MED-647', name: 'MD-Bel Pre Rd' },
  { location: 'MED-648', name: 'PA-Boothwyn' },
  { location: 'MED-651', name: 'TX-Irving' },
  { location: 'MED-652', name: 'TX-North Richland Hills' },
  { location: 'MED-653', name: 'TX-Richardson' },
  { location: 'MED-654', name: 'TX- Prosper' },
  { location: 'MED-655', name: 'TX-Carrolton-Trinity Mill Rd' },
  { location: 'MED-656', name: 'TX-Dallas-LBJ Freeway' },
  { location: 'MED-657', name: 'TX-Park Forest' },
  { location: 'MED-658', name: 'TX-Plano-Midway Rd' },
  { location: 'MED-659', name: 'TX-Prestonwood' },
  { location: 'MED-660', name: 'TX-Corsicana' },
  { location: 'MED-661', name: 'TX-North Arlington' },
  { location: 'MED-662', name: 'TX-Carrollton-Hebron Pkwy' },
  { location: 'MED-663', name: 'LA-Houma' },
  { location: 'MED-664', name: 'TX-Murphy' },
  { location: 'MED-665', name: 'TX-Plano-Parker Rd' },
  { location: 'MED-666', name: 'TX-McKinney' },
  { location: 'MED-667', name: 'MA-Memorial Parkway' },
  { location: 'MED-668', name: 'TN-Columbia' },
  { location: 'MED-669', name: 'MA-Newton' },
  { location: 'MED-670', name: 'MA-Brookline' },
  { location: 'MED-671', name: 'OH-Springfield-Limestone Street' },
  { location: 'MED-672', name: 'MA-Quincy' },
  { location: 'MED-673', name: 'TX-College Station' },
  { location: 'MED-674', name: 'TX-College Station South' },
  { location: 'MED-675', name: 'TX-Bryan' },
  { location: 'MED-676', name: 'TX-Beaumont' },
  { location: 'MED-677', name: 'TX-Southlake Town Square' },
  { location: 'MED-678', name: 'TX-Tanglewood' },
  { location: 'MED-679', name: 'IN-Fall Creek' },
  { location: 'MED-680', name: 'IL-Roselle' },
  { location: 'MED-681', name: 'OH-Perrysburg' },
  { location: 'MED-682', name: 'TN-Nolensville' },
  { location: 'MED-683', name: 'MD-College Park-Baltimore Avenue' },
  { location: 'MED-684', name: 'TX-Eagle Mountain' },
  { location: 'MED-685', name: 'NC-Raleigh-Green Rd' },
  { location: 'MED-686', name: 'OH-Westgate' },
  { location: 'MED-687', name: 'TX-Greenville' },
  { location: 'MED-688', name: 'TX-N. Beltline Rd' },
  { location: 'MED-689', name: 'PA-Latrobe' },
  { location: 'MED-690', name: 'PA-Somerset' },
  { location: 'MED-691', name: 'FL-Leesburg' },
  { location: 'MED-692', name: 'FL-The Villages' },
  { location: 'MED-693', name: 'CT-South Windsor' },
  { location: 'MED-694', name: 'CT-Berlin Turnpike' },
  { location: 'MED-695', name: 'OH-Norwalk' },
  { location: 'MED-696', name: 'CT-Southbury Green' },
  { location: 'MED-697', name: 'TX-Quarry Market' },
  { location: 'MED-698', name: 'WI-Downtown Racine' },
  { location: 'MED-699', name: 'TN-Bellevue' },
  { location: 'MED-700', name: 'PA-Monroeville' },
  { location: 'MED-701', name: 'WI-Cudahy' },
  { location: 'MED-702', name: 'GA-Roswell' },
  { location: 'MED-703', name: 'GA-Bridgemill' },
  { location: 'MED-704', name: 'PA-Lansdale' },
  { location: 'MED-705', name: 'PA-Chester Springs' },
  { location: 'MED-706', name: 'CO-South Colorado Blvd' },
  { location: 'MED-708', name: 'TX-Houston-South Voss' },
  { location: 'MED-709', name: 'TX-Katy-Grand Parkway' },
  { location: 'MED-710', name: 'TX-South Katy' },
  { location: 'MED-711', name: 'TN-Germantown-Exeter Village' },
  { location: 'MED-712', name: 'TN-Collierville' },
  { location: 'MED-713', name: 'TX-San Marcos' },
  { location: 'MED-714', name: 'WI-Grange-South Milwaukee' },
  { location: 'MED-715', name: 'TX-Orange' },
  { location: 'MED-716', name: 'TX-Silsbee' },
  { location: 'MED-718', name: 'IN-Fishers Lantern Rd' },
  { location: 'MED-719', name: 'MA-Northampton-Pleasant Street' },
  { location: 'MED-720', name: 'CO-Centennial' },
  { location: 'MED-722', name: 'TX-Parkdale Mall' },
  { location: 'MED-725', name: 'WI-Wauwatosa' },
  { location: 'MED-726', name: 'TX-Forney' },
  { location: 'MED-727', name: 'TX-Lakewood' },
  { location: 'MED-728', name: 'TX-Hurst' },
  { location: 'MED-729', name: 'TX-Keller' },
  { location: 'MED-730', name: 'TX-Roanoke' },
  { location: 'MED-732', name: 'TX-Westchase' },
  { location: 'MED-733', name: 'IN-Columbus-Washington Street' },
  { location: 'MED-734', name: 'TX-New Braunfels' },
  { location: 'MED-735', name: 'NC-Arden' },
  { location: 'MED-737', name: 'TX-Grand Prairie' },
  { location: 'MED-738', name: 'WI-Elm Grove' },
  { location: 'MED-739', name: 'TX-Park Cities' },
  { location: 'MED-741', name: 'TX-Burleson' },
  { location: 'MED-742', name: 'TX-Cedar Hill' },
  { location: 'MED-743', name: 'TX-Granbury' },
  { location: 'MED-744', name: 'PA-Strasburg' },
  { location: 'MED-745', name: 'FL-South Tampa' },
  { location: 'MED-746', name: 'AR-Sherwood' },
  { location: 'MED-747', name: 'IL-Des Plaines' },
  { location: 'MED-748', name: 'PA-Whitehall' },
  { location: 'MED-749', name: 'MA-Danvers' },
  { location: 'MED-750', name: 'MA-Topsfield' },
  { location: 'MED-751', name: 'MA-Beverly-Cabot St' },
  { location: 'MED-752', name: 'CO-Aurora-East Hampden Ave' },
  { location: 'MED-753', name: 'TX-Dripping Springs' },
  { location: 'MED-754', name: 'TX-Bedford' },
  { location: 'MED-755', name: 'TX-Grapevine' },
  { location: 'MED-756', name: 'TX-Grand Prairie - Pioneer Pkwy' },
  { location: 'MED-757', name: 'CO-Aurora-S. Cornerstar Way' },
  { location: 'MED-758', name: 'IL-Downers Grove' },
  { location: 'MED-760', name: 'OH-Bellevue' },
  { location: 'MED-761', name: 'TX-Spring Klein' },
  { location: 'MED-762', name: 'NC-Hendersonville-Four Seasons Blvd' },
  { location: 'MED-763', name: 'MA-Burlington' },
  { location: 'MED-764', name: 'TX-Sherwood Way' },
  { location: 'MED-765', name: 'CT-Buckland' },
  { location: 'MED-766', name: 'WI-Sheboygan' },
  { location: 'MED-767', name: 'OH-Wadsworth' },
  { location: 'MED-768', name: 'OH-North Canton' },
  { location: 'MED-769', name: 'FL-Port St John' },
  { location: 'MED-770', name: 'MD-Severna Park' },
  { location: 'MED-772', name: 'MI-Mason-South Cedar St' },
  { location: 'MED-717', name: 'CO-Englewood' },
];
